<template>
    <el-dialog :visible.sync="showImage">
        <img width="100%" :src="showImageUrl" alt="">
    </el-dialog>
</template>

<script>

    export default {
        props: {

        },
        components: {},
        data() {
            return {
                showImageUrl: '',
                showImage: false,
            }
        },
        computed: {},
        created() {

        },
        methods: {
            show(url){
                this.showImage = true
                this.showImageUrl = url
            }

        }
    }
</script>

<style lang="scss" module>
    @import '../../../assets/css/default';
</style>



// WEBPACK FOOTER //
// src/pages/serviceWorkOrder/dialog/showImageDialog.vue